import { requestAuthPost } from "./authInstance";

export const checkVoucherLimit = (payload) =>
  requestAuthPost("voucher/limit-check", payload, {
    headers: { "x-tz": "Asia/Jakarta" },
  });
